export const getObjectFromSearchParams: () => Record<string, string> = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return Object.fromEntries(urlSearchParams.entries());
};

export const getSearchFromObjectParams = (objectParams: Record<string, string>) => {
    const urlSearchParams = new URLSearchParams(objectParams);
    const searchString = urlSearchParams.toString();
    return searchString.length ? "?" + searchString : "";
};
